import { Box } from '@material-ui/core'
import {
  LineSeries,
  PointOrSliceMouseHandler,
  ResponsiveLineCanvas,
} from '@nivo/line'
import React from 'react'
import { COLOR_SCHEME_SET1, CustomSeries } from '../calibration/chart-util'
import { FullFormatOptions } from '../../../util/formatters'
import { Tooltip } from '../../common/charts/Tooltip'

type Props = {
  data: CustomSeries[]
  xFormatter: (value: number) => string
  yFormatter: (value: number, options?: FullFormatOptions) => string
  // xAxisFormatter: (value: number) => string
  axisBottomLegend?: string
  axisLeftLegend?: string
  showPoints: boolean
  legendItemWidth?: number
  onClick?: PointOrSliceMouseHandler<LineSeries>
}

export function SummaryLineChart({
  data: customSeries,
  xFormatter,
  yFormatter,
  // xAxisFormatter,
  axisBottomLegend,
  axisLeftLegend,
  showPoints,
  legendItemWidth,
  onClick,
}: Props): React.ReactElement {
  return (
    <>
      <Box display="flex" height="100%" justifyContent="flex-end">
        <Box position="relative" width="100%">
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            zIndex={0}
          >
            <ResponsiveLineCanvas
              data={customSeries}
              isInteractive
              enableGridX={false}
              margin={{ top: 8, right: 10, bottom: 90, left: 50 }}
              enablePoints={showPoints}
              colors={COLOR_SCHEME_SET1.slice(0, customSeries.length)}
              tooltip={(props) => Tooltip({ ...props, xFormatter, yFormatter })}
              onClick={onClick}
              lineWidth={customSeries[0].lineWidth}
              axisBottom={{
                legend: axisBottomLegend,
                legendOffset: 35,
              }}
              axisLeft={{
                // format: yFormatter,
                legend: axisLeftLegend,
                legendOffset: -35,
              }}
              xScale={{
                type: 'linear',
                min: 'auto',
                max: 'auto',
                nice: false,
              }}
              yScale={{
                type: 'linear',
                max: 'auto',
              }}
              layers={['grid', 'areas', 'lines', 'axes', 'legends']}
              legends={[
                {
                  anchor: 'bottom',
                  direction: 'row',
                  itemHeight: 10,
                  itemWidth: legendItemWidth ?? 100,
                  itemsSpacing: 20,
                  translateY: 65,
                  symbolSize: 20,
                },
              ]}
            />
          </Box>
        </Box>
      </Box>
    </>
  )
}
